import { render, staticRenderFns } from "./InviteExtDialog.vue?vue&type=template&id=50999450&scoped=true&"
import script from "./InviteExtDialog.vue?vue&type=script&lang=ts&"
export * from "./InviteExtDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InviteExtDialog.vue?vue&type=style&index=0&id=50999450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50999450",
  null
  
)

export default component.exports